// extracted by mini-css-extract-plugin
export default {"page":"FAQPage_page__kVpp6","lastUpdate":"FAQPage_lastUpdate__uOO5h","section":"FAQPage_section__WYaLb"};